<template>
  <div class="loading" :class="{'loading--active': active}">
  </div>
</template>

<script>
export default {
  name: 'loading',
  props: {
    active: Boolean
  }
}
</script>

<style lang="scss" scoped>
  .loading {
    position: fixed;
    top: -100px;
    left: 50%;
    transform: translateX(-50%);
    padding: 5px;
    border-radius: 50%;
    box-shadow: 2px 2px 6px 0 rgba(153, 153, 153, 0.4);
    background-color: #fff;
    z-index: 2000;
    transition: 0.4s;

    &--active {
      top: 60px;
    }

    &::after {
      content: '';
      display: block;
      padding: 8px;
      border-radius: 50%;
      border: solid 3px $primaryColor;
      border-top: solid 3px transparent;
      animation: loading 1s ease-in-out infinite;
    }
  }

  .content .loading {
    @media screen and (min-width: #{$media-900}) {
      left: calc(50% + 150px);

      &--active {
        top: 118px;
      }
    }
  }

  @keyframes loading {
    from {
      transform: rotate(0deg);
    }

    to {
      transform: rotate(360deg);
    }
  }
</style>
